'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by corupta on 20/07/17.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
/* eslint-env browser */


var DragItem = function (_React$Component) {
  _inherits(DragItem, _React$Component);

  function DragItem(props) {
    _classCallCheck(this, DragItem);

    var _this = _possibleConstructorReturn(this, (DragItem.__proto__ || Object.getPrototypeOf(DragItem)).call(this, props));

    _this.setMe = _this.setMe.bind(_this);
    _this.unlockBlock = _this.unlockBlock.bind(_this);
    _this.getMyStyle = _this.getMyStyle.bind(_this);
    _this.focusLock = _this.focusLock.bind(_this);
    _this.focusUnlock = _this.focusUnlock.bind(_this);
    _this.getFocusLocker = _this.getFocusLocker.bind(_this);
    _this.addEvents = _this.addEvents.bind(_this);
    _this.handleDown = _this.handleDown.bind(_this);
    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.moveFlyingItem = _this.moveFlyingItem.bind(_this);
    _this.blocked = false;
    _this.blockLocker = 0;
    _this.prevH = 0;
    _this.focusLocker = 0;
    return _this;
  }

  _createClass(DragItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setMe();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setMe();
    }
  }, {
    key: 'setMe',
    value: function setMe() {
      var di = _reactDom2.default.findDOMNode(this);
      if (di !== null) {
        this.me = di;
        this.addEvents(di);
        var stl = window.getComputedStyle(di, null);
        this.leftMargin = parseFloat(stl.marginLeft, 10);
        this.topMargin = parseFloat(stl.marginTop, 10);
        this.width = parseFloat(stl.width, 10);
        this.height = parseFloat(stl.height, 10);
        this.props.setHeight(this.props.myId, stl);
      }
    }
  }, {
    key: 'unlockBlock',
    value: function unlockBlock(blockLocker) {
      if (this.blockLocker === blockLocker) {
        this.blocked = false;
      }
    }
  }, {
    key: 'getMyStyle',
    value: function getMyStyle() {
      var ans = typeof this.props.children.props.style === 'undefined' ? {} : _extends({}, this.props.children.props.style);
      if (this.props.destroyer) {
        ans.display = 'none';
        ans.touchAction = 'none';
        ans.pointerEvents = 'none';
      } else {
        if (this.props.trans.H !== 0) {
          ans.transform = 'translate(0, ' + this.props.trans.H + 'px)';
          ans.WebkitTransform = 'translate(0, ' + this.props.trans.H + 'px)';
        }
        if (this.prevH !== this.props.trans.H) {
          this.prevH = this.props.trans.H;
          this.blocked = true;
          var blockLocker = ++this.blockLocker;
          setTimeout(this.unlockBlock, this.props.trans.dur, blockLocker);
        }
        ans.transitionDuration = this.props.trans.dur + 'ms';
        ans.userSelect = 'none';
        ans.zIndex = 1;
      }
      return ans;
    }
  }, {
    key: 'focusLock',
    value: function focusLock() {
      ++this.focusLocker;
    }
  }, {
    key: 'focusUnlock',
    value: function focusUnlock() {
      --this.focusLocker;
    }
  }, {
    key: 'getFocusLocker',
    value: function getFocusLocker() {
      return this.focusLocker;
    }
  }, {
    key: 'addEvents',
    value: function addEvents(di) {
      di.addEventListener('supermove', this.moveFlyingItem);
      di.addEventListener('enterMeh', this.handleEnter);
      di.addEventListener('focusin', this.focusLock);
      di.addEventListener('focusout', this.focusUnlock);
      if (window.PointerEvent) {
        di.addEventListener('pointerdown', this.handleDown);
      } else {
        di.addEventListener('mousedown', this.handleDown);
        di.addEventListener('touchstart', this.handleDown);
      }
    }
  }, {
    key: 'handleDown',
    value: function handleDown(e) {
      var p = e.type === 'touchstart' || e.type === 'pointerdown' && (e.pointerType === 'pen' || e.pointerType === 'touch');
      var t = !p && e.button === 0;
      if (p || t) {
        var getRect = this.me.getBoundingClientRect();
        var stl = { left: getRect.left, top: getRect.top };
        var rel = void 0;
        if (p) {
          rel = { left: stl.left - e.touches.item(0).clientX, top: stl.top - e.touches.item(0).clientY };
        } else {
          rel = { left: stl.left - e.clientX, top: stl.top - e.clientY };
        }
        this.props.setRelatives(stl, rel);
        this.props.onSthDown(this.props.myId, stl, p, e, this.me, { width: this.width, height: this.height }, this.getFocusLocker);
      }
    }
  }, {
    key: 'handleEnter',
    value: function handleEnter(e) {
      this.props.onSthEnter(this.props.myId);
      e.stopPropagation();
    }
  }, {
    key: 'moveFlyingItem',
    value: function moveFlyingItem(e) {
      if (this.blocked === false) {
        var rect = this.me.getBoundingClientRect();
        this.props.onsupermove(this.me, this.props.myId, { top: rect.top, bottom: rect.bottom });
      }
      e.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      //if (this.blocked) {
      //  console.log('blocked');
      //}
      return _react2.default.cloneElement(this.props.children, { style: this.getMyStyle(), className: typeof this.props.class === 'undefined' ? '' : this.props.class });
    }
  }]);

  return DragItem;
}(_react2.default.Component);

exports.default = DragItem;


DragItem.PropTypes = {
  setHeight: _propTypes2.default.func.isRequired,
  willSetHeight: _propTypes2.default.bool.isRequired,
  trans: _propTypes2.default.shape().isRequired,
  setRelatives: _propTypes2.default.func.isRequired,
  onSthDown: _propTypes2.default.func.isRequired,
  onSthEnter: _propTypes2.default.func.isRequired,
  onsupermove: _propTypes2.default.func.isRequired,
  myId: _propTypes2.default.number.isRequired,
  myGid: _propTypes2.default.number.isRequired,
  destroyer: _propTypes2.default.bool.isRequired,
  class: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ./~/drag-drop-list-react/dist/DragItem.js
// module id = 87
// module chunks = 0